export type FeatureFlag = {
  nome: string
  slug: string
  situacao: string
  configuracoes: Config[]
}

export enum FeatureFlagSituationEnum {
  ATIVO = 'ativo',
  INATIVO = 'inativo',
  ARQUIVADO = 'arquivado',
}

export enum FeatureFlagKeyEnum {
  CHAVE_MODO_MANUAL = 'smart_delivery_modo_manual',
  CHAVE_MODO_AUTOMATICO = 'smart_delivery_modo_automatico',
}

export type Config = {
  entidade_id: number
  chave: FeatureFlagKeyEnum
  situacao: FeatureFlagSituationEnum
}

export type FeatureFlagEntidadeParams = {
  featureFlag: string
}
